var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('b-img',{attrs:{"src":_vm.info.src,"fluid":"","alt":_vm.info.alt}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }